export function RandomGradientBar() {
  return (
    <div className="-mx-px -mt-px h-2 bg-linear-to-r from-primary to-primary/75 sm:rounded-t-2xl" />
  );
}
